import { useTheme } from "@mui/material/styles";  
import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import {
  cardStyles,
  cardContentStyles,
  titleStyles,
  subtitleStyles,
  priceStyles,
  weightStyles,
} from "./paymentContent.styles";

function PaymentContent({ name, district, price, weight,nameCity }) {
  const theme = useTheme(); 

  return (
    <Card sx={cardStyles(theme)}>
      <CardContent sx={cardContentStyles}>
        <Typography variant="h4" fontWeight={600} gutterBottom sx={titleStyles(theme)}>
          Оплата товара
        </Typography>

        <Typography variant="h6" fontWeight={500} gutterBottom sx={subtitleStyles(theme)}>
          🛍️ <strong>{name}</strong>
        </Typography>

        <Typography variant="h6" fontWeight={500} gutterBottom sx={subtitleStyles(theme)}>
          📍 <strong>{nameCity}</strong>
        </Typography>

        <Typography variant="h6" fontWeight={500} gutterBottom sx={subtitleStyles(theme)}>
          📍 <strong>{district}</strong>
        </Typography>

        <Typography variant="h5" fontWeight={600} color="primary" gutterBottom sx={priceStyles(theme)}>
          💰 {price} руб.
        </Typography>

        <Typography variant="h5" fontWeight={600} gutterBottom sx={weightStyles(theme)}>
          ⚖️ {weight} г
        </Typography>
      </CardContent>
    </Card>
  );
}

export default PaymentContent;
